<script setup>
import { Icon } from '@components'

const props = defineProps({
    link: {
        type: Object
    },
    title: {
        type: String,
    },
    subtitle: {
        type: String,
    },
    icon: {
        type: String,
    }
})
</script>

<style>

</style>

<template>
    <router-link :to="props.link" class="lg:w-[563px] transition-all flex items-center justify-between gap-2 border p-5 rounded-lg border-[#D0D5DD] hover:bg-[#F9FAFB]">
        <div class="flex flex-col gap-2">
            <div class="text-[#101828] text-xl font-semibold">{{ props.title }}</div>
            <div v-if="props.subtitle" class="text-[#667085] text-sm font-normal">{{ props.subtitle }}</div>
        </div>
        <div>
            <Icon :name="props.icon" class="text-[#333333]" />
        </div>
    </router-link>
</template>
